let url = 'https://crmapi.gpsleaders.com:8443/graphql'

if (window.location.hostname == 'crm.gpsleaders.com') {  
  url = 'https://crmapi.gpsleaders.com:8443/graphql'
}

/*
if (window.location.hostname == 'localhost') {
  url = 'http://localhost:8080/graphql'
}
  */

//console.log('Protocol: ', window.location.protocol)

export default class Ds {
  query(query, callback) {
    fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'Authorization': localStorage.getItem('userHash') || '' },
      body: JSON.stringify({
          query: query
      })
    })
    .then((res) => res.json())
    // Always hand callers `data` or `null` — never `undefined`. On auth/GraphQL
    // errors the response body has no `data` key, so callers can null-check
    // instead of dereferencing undefined and hanging. The request-error handler
    // is the 2nd arg (not a trailing .catch) so a throwing callback can't
    // re-trigger it and invoke the callback twice.
    .then(
      (data) => { callback(data && data.data ? data.data : null) },
      (err) => { console.log('ERROR: ', err); callback(null) }
    )
    .catch((err) => { console.log('ERROR (callback threw): ', err) })
  }

  async queryPromise(query) {
    return fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'Authorization': localStorage.getItem('userHash') || '' },
      body: JSON.stringify({query})
    })
    .then((res) => res.json())
    .catch((err) => { console.log('ERROR: ', err) })
  }
}



// WEBPACK FOOTER //
// ./src/stores/ds.js